import { GET_FAQ_INFO, FAQ_INFO_ERROR } from "../types";

const initialState = {
  faqInfo: {},
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_FAQ_INFO:
      return {
        ...state,
        faqInfo: action.payload,
        loading: false,
      };
    case FAQ_INFO_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
